import { type SxProps, type Theme } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';

export const FullPageSpinnerStyles: SxProps<Theme> = {
  alignItems: 'center',
  backgroundColor: theme => theme.palette.common.white,
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  overflow: 'auto',
  width: '100%',
};

export const FullPageSpinnerInnerStyles: SxProps<Theme> = {
  animation: 'rotate 1.2s linear infinite',
  border: `5px solid ${themeColors.spinnerColor}`,
  borderColor: `${themeColors.spinnerColor} transparent ${themeColors.spinnerColor} transparent`,
  borderRadius: '50%',
  display: 'block',
  height: 92,
  margin: 1,
  width: 92,
};
